import { useState, useRef } from "react";
import "./Sustainability23.scss";
import Banner from "../../../Common/Banner/Banner";
import { SUSTAINABILITY_23 } from "../../Sustainability/SustainabilityData";
// import Button from "../../../Common/Buttons/button";
import TwoColumnLayout from "../../../Common/TwoColumnLayout/TwoColumnLayout";
import Modal from "../../../Common/Modal/modal";
import iconPathURL from "../../../Common/iconPath";

const iconPath = process.env.PUBLIC_URL + "/assets/images/";

export default function Suatainability23() {
  const agendaRef = useRef(null);
  const speakerRef = useRef(null);
  const [isModalVisible, setModalVisibility] = useState(false);

  const [name, setName] = useState("");

  const modalSpeaker = () => {
    let speakerContent = SUSTAINABILITY_23.speakers_info[name];
    return (
      <Modal
        show={isModalVisible}
        handleClose={() => setModalVisibility(false)}
      >
        {speakerContent && (
          <div className="table-content">
            <button
              className="button-container"
              onClick={() => setModalVisibility(false)}
            >
              <img
                style={{ height: 20, width: 20 }}
                src={iconPathURL("common/close.png")}
                alt="img"
              ></img>
            </button>
            <div className="row  modal-view">
              <div className="col-xs-12 col-md-3 col-lg-3">
                <img
                  alt="logo"
                  src={`${iconPath}sustainability-23/${speakerContent.image}`}
                  style={{ width: "70%" }}
                ></img>
              </div>
              <div
                className="col-xs-12 col-md-8 col-lg-8"
                style={{ paddingTop: "4rem" }}
              >
                <span
                  className="speaker-name"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.open(speakerContent.url, "_blank");
                  }}
                >
                  {speakerContent.name}
                </span>
                <p className="modal-contents">{speakerContent.designation}</p>
              </div>
            </div>
            <div className="profile-desc">
              <p className="modal-contents">{speakerContent.details1}</p>
              <p className="modal-contents">{speakerContent.details2}</p>
              <p className="modal-contents">{speakerContent.details3}</p>
              <p className="modal-contents">{speakerContent.details4}</p>
            </div>
          </div>
        )}
      </Modal>
    );
  };

  const registerPopup = () => {
    return (
      <div className="popup-content">
        <p class="title">The event's live stream is ended</p>
        {/* <p class="title">
          Registered Participants click here to watch the event now!
        </p>
        <p className="pop-details">
          *Only the registered attendees can watch the livestreaming of the
          event.
        </p>
        <a
          target="new"
          href={"https://webcast.meetyoo.de/index.html?e=wpyiZds1GW0O"}
        >
          <Button
            style="know-more-button-content content"
            popUp="true"
            label="Click Here"
          />
        </a> */}
      </div>
    );
  };
  const CardView1 = (props) => {
    const body = () => {
      return (
        <div>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => {
              setName(props.item.name1);
              setModalVisibility(true);
            }}
          >
            {props.item.name1}
          </th>
          <div>
            <p>
              <strong>
                <p className="describe">{props.item.designation1}</p>
              </strong>
            </p>
          </div>
        </div>
      );
    };
    return (
      <div className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <TwoColumnLayout
          imgStyle="col-xs-12 col-sm-4 col-md-4 col-lg-4 first-column"
          style="col-xs-12 col-sm-8 col-md-8 col-lg-8 second-column"
          imgSrc={
            props.item.image1 &&
            `${`${iconPath}sustainability-23/${props.item.image1}`}`
          }
          body={props.item.image1 && body()}
        ></TwoColumnLayout>
      </div>
    );
  };
  const CardView2 = (props) => {
    const body = () => {
      return (
        <div>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => {
              setName(props.item.name2);
              setModalVisibility(true);
            }}
          >
            {props.item.name2}
          </th>
          <div>
            <p>
              <strong>
                <p className="describe">{props.item.designation2}</p>
              </strong>
            </p>
          </div>
        </div>
      );
    };
    return (
      <div className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <TwoColumnLayout
          imgStyle="col-xs-12 col-sm-4 col-md-4 col-lg-4 first-column"
          style="col-xs-12 col-sm-8 col-md-8 col-lg-8 second-column"
          imgSrc={
            props.item.image2 &&
            `${`${iconPath}sustainability-23/${props.item.image2}`}`
          }
          body={body()}
        ></TwoColumnLayout>
      </div>
    );
  };

  const sustainabilityTable = () => {
    return (
      <div ref={agendaRef} className={"table-content"}>
        <div className="first-table">
          <h2 className={"agenda-text"}>Agenda</h2>
        </div>
        <div className="head">
          <div className="col-xs-12 col-md-4 col-lg-4 time-text">Time</div>
          <div
            className="col-xs-12 col-md-4 col-lg-4 time-text"
            style={{ textAlign: "left" }}
          >
            Topic
          </div>

          <div className="col-xs-12 col-md-4 col-lg-4 time-text">Speakers</div>
        </div>

        {SUSTAINABILITY_23.agenda?.map((item) => (
          <div className="row contents">
            <div className="col-xs-12 col-md-4 col-lg-4 date-text">
              {item.date}
            </div>
            <div className="col-xs-12 col-md-3 col-lg-3 date-text">
              {item.topic}
            </div>
            <div className="col-xs-12 col-md-5 col-lg-5  list-text">
              <ul>
                {item.p1 && <li>{item.p1}</li>}
                {item.p2 && <li>{item.p2}</li>}
                {item.p3 && <li>{item.p3}</li>}
                {item.p4 && <li>{item.p4}</li>}
                {item.p5 && <li>{item.p5}</li>}
              </ul>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const speakerTable = () => {
    return (
      <div ref={speakerRef}>
        <div className="table-content">
          <table>
            <thead>
              <tr className="header-table">
                <th className="title-text">Mercedes-Benz Speakers</th>
                <th className="title-text">Guest Speakers</th>
              </tr>
            </thead>
          </table>
          <table>
            <div>
              {SUSTAINABILITY_23.speakers?.map((item, index) => (
                <div className="speaker-item">
                  <div className="col-xs-12 col-md-6 col-lg-6 date-text">
                    <CardView1 item={item} index={index} />
                  </div>
                  <div className="col-xs-12 col-md-6 col-lg-6 date-text">
                    <CardView2 item={item} index={index} />
                  </div>
                </div>
              ))}
            </div>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="sustain-container">
      {modalSpeaker()}
      <div>
        <Banner
          imgSrc={iconPath + "sustainability-23/sustainability_23.png"}
          title=""
        />
      </div>
      <section
        className="img-sustain"
        style={{
          backgroundImage: `url(${iconPathURL(
            "sustainability-23/sustain.png"
          )}`,
          backgroundRepeat: "round",
        }}
      >
        {registerPopup()}
      </section>

      <section
        className="img-sustain-mobile"
        style={{
          backgroundImage: `url(${iconPathURL(
            `sustainability-23/sustain_mobile.png`
          )}`,
          backgroundRepeat: "round",
        }}
      >
        {registerPopup()}
      </section>
      {sustainabilityTable()}
      {speakerTable()}
    </div>
  );
}
